import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/animated-tabs';
import { ROUTES_CONFIG } from '@/config/routes.config'
import { useTRPC } from '@/trpc'
import { useQuery } from '@tanstack/react-query'
import React, { useState } from 'react'
import { useTypedParams } from 'react-router-typesafe-routes'
import Dashboard from './(tabs)/dashboard'

const ClubDetailPage = () => {
    const { trpc } = useTRPC()
    const { club_id } = useTypedParams(ROUTES_CONFIG.APP.CLUB_DETAIL)

    const [tab, setTab] = useState<string>('dashboard');

    const { data: club } = useQuery({
        queryKey: ['club', club_id],
        queryFn: async () => {
            const club = await trpc.clubs.getById.query({
                club_id: club_id,
                with_players: true
            });
            return club;
        }
    })

    const playerCount =
        club && "players" in club && Array.isArray((club as any).players)
            ? club.players.length
            : "-";

    return (
        <div className='p-4 flex flex-col gap-4 justify-between h-full'>
            <header className='flex items-center gap-10'>
                <div className='size-32 aspect-square relative'>
                    <div className='h-full w-full bg-foreground/10 rounded-full flex items-center justify-center outline-2 outline-bright outline-offset-4'>
                        <Avatar className='w-full h-full'>
                            <AvatarImage className='object-contain' src={club?.imageUrl ?? undefined} alt="" />
                            <AvatarFallback className='bg-foreground/10 text-3xl opacity-50'>{club?.name?.charAt(0)}</AvatarFallback>
                        </Avatar>
                    </div>
                </div>

                <div className='flex flex-col gap-2'>
                    <div className='flex items-center gap-3'>
                        <p className='text-3xl font-semibold'>{club?.name}</p>
                    </div>

                    <div className='py-2 px-4 bg-foreground/10 rounded-md flex items-center gap-4 w-fit'>
                        <div className='flex items-center gap-3'>
                            <p className='text-sm text-foreground/50'>Spelers</p>
                            <p>{playerCount}</p>
                        </div>
                    </div>
                </div>
            </header>

            <main className='bg-foreground/10 h-full overflow-auto rounded-lg'>
                <div className='flex flex-col justify-between h-full'>
                    <div className='border-b p-2'>
                        <Tabs value={tab} onValueChange={setTab}>
                            <TabsList className='p-0'>
                                <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
                            </TabsList>
                        </Tabs>
                    </div>
                    <div className='h-full overflow-auto p-4'>
                        <div className='flex flex-col'>
                            {tab === "dashboard" && <Dashboard />}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default ClubDetailPage